import { Component, OnInit, OnDestroy, Pipe, PipeTransform, ViewChild } from '@angular/core';
import { FormGroup, FormControl, FormGroupDirective, Validators } from '@angular/forms';
import { RestCallerService } from '../common/services/rest-caller.service';
import { OrderByPipe } from '../common/pipes/orderby.pipe';
import { AppComponent } from '../app.component';

declare var $: any;
declare var swal: any;
declare var alasql: any;
declare var moment: any;
declare var google: any;

@Component({
  selector: 'app-log-book',
  templateUrl: './log-book.component.html',
  styleUrls: ['./log-book.component.css'],
})

export class LogBookComponent implements OnInit, OnDestroy {

  showLoader: boolean = false;

  years: string[];
  yearsNum: number[];
  quarters: string[];
  quartersNum: number[];
  internalUsersList: any = [];
  taskStatusList: string[];

  logData: Object[] = [];
  reportData: Object[] = [];
  filteredData: Object[] = [];
  filterValue: string;
  selectedLogData: any;

  selectedQuarter: string;
  selectedYear: string;

  displayQuarter: string;
  displayYear: string;

  isDesc: boolean = false;
  column: string = 'CategoryName';
  direction: number;

  editForm: FormGroup;

  inDateInput: Date = new Date();
  outDateInput: Date = new Date();

  public queryClientList = '';
  public filteredClientList = [];
  clientList: any;
  selectedClient: any;

  inDateTotal: number = 0;
  outDateTotal: number = 0;

  currentQuarterStart: any;

  showLogBookReport: boolean = false;

  @ViewChild(FormGroupDirective) editFormDirective;

  constructor(private restCallingService: RestCallerService) {

  }

  ngOnDestroy() {
    $('.nav>li.active').removeClass("active");
  }

  ngOnInit() {
    $('#log-book').addClass('active');
    this.years = [];
    this.yearsNum = [];
    this.quarters = ['Q1', 'Q2', 'Q3', 'Q4'];
    this.quartersNum = [1, 2, 3, 4];
    this.determineYears();
    this.taskStatusList = ['Pending' , 'Review' , 'Complete'];

    this.editForm = new FormGroup({
      'payerId': new FormControl(null, Validators.required),
      'clientName': new FormControl(null),
      'year': new FormControl(null, Validators.required),
      'quarter': new FormControl(null, Validators.required),
      'inDate': new FormControl(null),
      'outDate': new FormControl(null),
      'deliveryMode': new FormControl(null),
      'status': new FormControl(null),
      'internalComments': new FormControl(null),
      'clientComments': new FormControl(null),
      'assignedTo': new FormControl(null),
      'taskStatus': new FormControl(null),
      'iManageURL': new FormControl(null)
    });
    this.showLoader = true;
    this.restCallingService.getListofClientForInternalUser({}).subscribe(
      data => {
        this.showLoader = false;
        this.clientList = data.json().filter(function (a) { return a.name !== null; }).sort(function (a, b) {
          if (a.name.toUpperCase() < b.name.toUpperCase()) { return -1; }
          if (a.name.toUpperCase() > b.name.toUpperCase()) { return 1; }
          return 0;
        });
      },
      err => {
        this.showLoader = false;
        console.log(err.json());
        swal('Failure!', err.json().message,'error');
      }); 
      this.getCurrentYearAndQuarter();
      this.getInternalUserList();

  }

  getInternalUserList() {
      this.restCallingService.getUserList().subscribe(
        data => {
          let usersList = data.json();
          for(var i = 0 ; i <  usersList.length ; i++){
            if(!usersList[i].externalUser) {
              this.internalUsersList.push(usersList[i]);
            }
          }
         
        },
        err => {
          swal("Failure", err.json().message, 'error');
        });
  }

  getCurrentYearAndQuarter() {
    const configKeyValuePairs = JSON.parse(sessionStorage.getItem('currentUser'))['configKeyValuePairs'];
    this.currentQuarterStart = moment(configKeyValuePairs['CURRENT_QUARTER_START_YYYYMMDD']);
    this.selectedYear = this.currentQuarterStart.year().toString();
    this.selectedQuarter = 'Q' + this.currentQuarterStart.quarter().toString();
  }

  determineYears() {
    let currentYearNum = Number(moment().format('YYYY'));
    this.yearsNum.push(currentYearNum, currentYearNum-1, currentYearNum-2);
    this.years.push(currentYearNum.toString(), (currentYearNum-1).toString(), (currentYearNum-2).toString());
  }

  editSelectedRow(data) {
    if (data !== undefined) {
      this.editForm.reset();
      this.editForm.controls['clientName'].disable();
      this.selectedLogData = Object.assign({}, data); //deep copy of data object so we're not modifying the table in memory;
      for (const value in data) {
        if (this.editForm.controls[value] !== undefined) {
          this.editForm.controls[value].setValue(data[value]);
        }
      }
    }
    this.inDateInput = this.parseDate(data['inDate']);
    this.outDateInput = this.parseDate(data['outDate']);
    this.editForm.controls['inDate'].setValue(this.inDateInput);
    this.editForm.controls['outDate'].setValue(this.outDateInput);
  }

  resetData() {
    this.logData = [];
    this.filteredData = [];
    this.getCurrentYearAndQuarter();
    this.displayQuarter = "";
    this.displayYear = "";
  }

  resetForm() {
    this.selectedLogData = null;
    this.editForm.reset();
    this.editFormDirective.resetForm();
    this.editForm.controls['clientName'].enable();
  }

  parseDate(dateString: string) {
    if (dateString) {
      return new moment(dateString).toDate();
    } else {
      return null;
    }
  }

  getLogBookData() {
    if (this.selectedQuarter && this.selectedYear) {
      this.filterValue = '';
      this.displayQuarter = this.selectedQuarter;
      this.displayYear = this.selectedYear;
      let yearNum: number = Number(this.selectedYear);
      let quarterNum: number = Number(this.selectedQuarter.charAt(1));
      this.showLoader = true;
      this.restCallingService.getLogBookForYearAndQuarter(yearNum, quarterNum).subscribe(resp => {
        this.showLoader = false;
        this.logData = resp.json();
        this.filteredData = this.logData.slice(0);
        this.reportData = this.buildLogBookReport(yearNum, quarterNum);
        this.drawAreaChart();
      },
        err => {
          this.showLoader = false;
          console.log(err.json());
          swal('Failure!',err.json().message,'error');
        });
    }
    else {
      swal('Error:', 'Please select both year and quarter to proceed.', 'warning');
    }
  }

  buildLogBookReport(year: number, quarter: number) {
    let quarterStart = moment().year(year).quarter(quarter).startOf('quarter');
    let currentDate = moment();
    let endDate;
    let date = quarterStart;
    let inDateRunningTotal = 0;
    let outDateRunningTotal = 0;
    let reportTable = [];
    this.inDateTotal = 0;
    this.outDateTotal = 0;
    if (quarterStart.isSame(this.currentQuarterStart))
      endDate = currentDate;
    else
      endDate = moment().year(year).quarter(quarter).endOf('quarter').add(30, 'days');
    while (date.isBefore(endDate)) {
      let reportTableRecord = [];
      let inDateRecords = this.logData.filter(record => moment(record['inDate']).isSame(date));
      let outDateRecords = this.logData.filter(record => moment(record['outDate']).isSame(date));
      let inDateCount : number = inDateRecords.length > 0 ? inDateRecords.length : 0;
      let outDateCount : number = outDateRecords.length > 0 ? outDateRecords.length : 0;
      this.inDateTotal += inDateCount;
      this.outDateTotal += outDateCount;
      reportTableRecord['date'] = date;
      reportTableRecord['inDateCount'] = inDateCount;
      reportTableRecord['outDateCount'] = outDateCount;
      reportTableRecord['inDateRunningTotal'] = this.inDateTotal;
      reportTableRecord['outDateRunningTotal'] = this.outDateTotal;
      reportTable.push(reportTableRecord);
      date = moment(date).add(1, 'days');
    }
    return reportTable;
  }

  saveLogBookData() {
    if (this.editForm.valid == true) {
      if ((this.editForm.controls['clientComments'].value && this.editForm.controls['clientComments'].value.length > 250) ||
          (this.editForm.controls['internalComments'].value && this.editForm.controls['internalComments'].value.length > 250)) {
            swal('Failure!', 'Error: Comment fields can only contain a maximum of 250 characters', 'error');
            return;
      }
      if (this.selectedLogData !== null && this.selectedLogData !== undefined) {
        if (!this.validateYearAndQuarter(this.editForm.value.year, this.editForm.value.quarter)) {
          swal('Failure!', 'Error: Cannot create a Log Book Record in a future quarter.', 'error');
          return;
        }
        if (this.inDateInput) {
          if (!this.validateInAndOutDate(this.editForm.value.inDate, this.editForm.value.year, this.editForm.value.quarter)) {
            swal('Failure!', 'Error: In Date must be between the selected quarter start date and today\'s date.', 'error');
            return;
          }
          this.selectedLogData['inDate'] = moment(this.inDateInput).format('YYYY-MM-DD');
        }
        else {
          this.selectedLogData['inDate'] = null;
        }
        if (this.outDateInput) {
          if (!this.validateInAndOutDate(this.editForm.value.outDate, this.editForm.value.year, this.editForm.value.quarter)) {
            swal('Failure!', 'Error: Out Date must be between the selected quarter start date and today\'s date.', 'error');
            return;
          }
          this.selectedLogData['outDate'] = moment(this.outDateInput).format('YYYY-MM-DD');
        }
        else {
          this.selectedLogData['outDate'] = null;
        }
        this.callUpdateLogBookService();
      } else {
        const newLogBookData = this.editForm.value;
        newLogBookData.clientId = this.selectedClient['id'];
        if (!this.validateYearAndQuarter(this.editForm.value.year, this.editForm.value.quarter)) {
          swal('Failure!', 'Error: Cannot create a Log Book Record in a future quarter.', 'error');
          return;
        }
        if (newLogBookData['inDate']) {
          if (!this.validateInAndOutDate(this.editForm.value.inDate, this.editForm.value.year, this.editForm.value.quarter)) {
            swal('Failure!', 'Error: In Date must be between the selected quarter start date and today\'s date.', 'error');
            return;
          }
          newLogBookData['inDate'] = moment(this.inDateInput).format('YYYY-MM-DD');
        }
        if (newLogBookData['outDate']) {
          if (!this.validateInAndOutDate(this.editForm.value.outDate, this.editForm.value.year, this.editForm.value.quarter)) {
            swal('Failure!', 'Error: Out Date must be between the selected quarter start date and today\'s date.', 'error');
            return;
          }
          newLogBookData['outDate'] = moment(this.outDateInput).format('YYYY-MM-DD');
        }
        this.callCreateNewLogBookService(newLogBookData);
      }
    }
    else {
      for (const fieldName of Object.keys(this.editForm.controls)) {
        if (this.editForm.controls[fieldName].valid === false) {
          this.editForm.controls[fieldName].markAsTouched({ onlySelf: true });
        }
      }
      swal('Failure!', 'Error: Please check one or more fields', 'error');
    }
  }

  disassembleiManageURL(selectedLogDataiManageURL) {
    let iManageURL = selectedLogDataiManageURL;
    if (selectedLogDataiManageURL != null) {
      if (selectedLogDataiManageURL.startsWith("https://")) {
        iManageURL = selectedLogDataiManageURL.replace("https://", '');
      }

      if (selectedLogDataiManageURL.startsWith("http://")) {
        iManageURL = selectedLogDataiManageURL.replace("http://", '');
      }
    }
    return iManageURL;
  }

  fillSelectedLogBookData() {
    for (const data of Object.keys(this.selectedLogData)) {
      if (this.editForm.value[data] !== undefined && data != 'inDate' && data != 'outDate') { //we set the dates ourselves
        this.selectedLogData[data] = this.editForm.value[data];
      }
    }
  }

  deleteLogBook(data) {
    swal({ title: 'Are you sure?', text: 'Are you sure you want to delete this Log Book record?', icon: 'warning', buttons: true }).then(
      (isConfirmed) => {
        if (isConfirmed) {
          this.showLoader = true;
          this.restCallingService.deleteLogBook(data.id).subscribe(deleteResp => {
            this.showLoader = false;
            swal('Success!', 'Log Book record Deleted Successfully!', 'success').then(()=>{
              if (this.selectedQuarter && this.selectedYear) {
                this.getLogBookData();
              }
            });
          }, err => {
            this.showLoader = false;
            swal('Failure!',err.json().message,'error');
            console.log(err.json());
          });
        };
      }
    );
  }

  callUpdateLogBookService() {
    this.fillSelectedLogBookData();
    this.showLoader = true;
    this.selectedLogData['iManageURL'] = this.disassembleiManageURL(this.selectedLogData['iManageURL']);
    this.restCallingService.updateLogBook(this.selectedLogData.id, this.selectedLogData).subscribe(data => {
      this.showLoader = false;
      this.selectedLogData = null;
      $('#editModal').modal('toggle');
      swal('Success!', 'Log Book Data Updated Successfully!', 'success').then(()=>{
        if (this.selectedQuarter && this.selectedYear) {
          this.getLogBookData();
        }
      });
    }, err => {
      this.showLoader = false;
      swal('Failure!', err.json().message,'error');
      console.log(err.json());
    });
  }

  callCreateNewLogBookService(newLogBookData) {
    this.showLoader = true;
    newLogBookData['iManageURL'] = this.disassembleiManageURL(newLogBookData['iManageURL']);
    this.restCallingService.createLogBook(newLogBookData).subscribe(data => {
      this.showLoader = false;
      $('#editModal').modal('toggle');
      swal('Success!', 'New Log Book Data added Successfully!', 'success').then(()=>{
        if (this.selectedQuarter && this.selectedYear) {
          this.getLogBookData();
        }
      });
    }, err => {
      this.showLoader = false;
      swal('Failure!', err.json().message,'error');
      console.log(err.json());
    });
  }

  sort(property) {
    this.isDesc = !this.isDesc;
    this.column = property;
    this.direction = this.isDesc ? 1 : -1;
  };

  filterData() {
    if (this.filterValue !== '' && this.logData !== undefined) {
      this.filteredData = this.logData.filter(function (el) {
        return (el.payerId && el.payerId.toLowerCase().indexOf(this.filterValue.toLowerCase()) >= 0) ||
          (el.clientName && el.clientName.toLowerCase().indexOf(this.filterValue.toLowerCase()) >= 0) ||
          (el.inDate && el.inDate.indexOf(this.filterValue) >= 0) ||
          (el.outDate && el.outDate.indexOf(this.filterValue) >= 0) ||
          (el.deliveryMode && el.deliveryMode.toLowerCase().indexOf(this.filterValue.toLowerCase()) >= 0) ||
          (el.status && el.status.toLowerCase().indexOf(this.filterValue.toLowerCase()) >= 0) ||
          (el.internalComments && el.internalComments.toLowerCase().indexOf(this.filterValue.toLowerCase()) >= 0) ||
          (el.clientComments && el.clientComments.toLowerCase().indexOf(this.filterValue.toLowerCase()) >= 0);
      }.bind(this));
    } else {
      this.filteredData = this.logData;
    }
  }

  filterClientList() {
    if (this.queryClientList !== '' && this.clientList !== undefined) {
      this.filteredClientList = this.clientList.filter(function (el) {
        return el.name.toLowerCase().indexOf(this.queryClientList.toLowerCase()) >= 0;
      }.bind(this));
    } else {
      this.filteredClientList = this.clientList.slice(0, 9);
    }
    this.filteredClientList = this.filteredClientList.slice(0, 9);
  }

  clientFocus() {
    this.filteredClientList = this.clientList.slice(0, 9);
  }

  onClientSelection(item) {
    this.selectedClient = item;
    this.queryClientList = item.name;
    this.editForm.controls['payerId'].setValue(this.selectedClient.payerId)
    this.filteredClientList = [];
  }

  toggleReportSection() {
    if ($('.report-icon').hasClass('fa-plus-circle')) {
      $("#reportSection").slideDown();
      $('.report-icon').toggleClass('fa-plus-circle fa-minus-circle');
      this.showLogBookReport = true;
      this.drawAreaChart();
    }
    else {
      $("#reportSection").slideUp();
      $('.report-icon').toggleClass('fa-plus-circle fa-minus-circle');
      this.showLogBookReport = false;
    }
  }

  waitForLibraryLoadedAndDivAvailable(): boolean {
    if (!AppComponent.googleChartLibraryLoaded) {
      setTimeout(() => { this.drawAreaChart(); }, 250);
      return true;
    }
    if (!document.getElementById('chartDiv')) {
      setTimeout(() => { this.drawAreaChart(); }, 250);
      return true;
    }
    return false;
  }

  drawAreaChart() {
    if (this.waitForLibraryLoadedAndDivAvailable())
      return;
    let arrayOfArrays = [['Date', 'Total In', 'Total Out']];
    for (var record of this.reportData) {
      let array = [];
      array.push(moment(record['date']).toDate());
      array.push(record['inDateRunningTotal']);
      array.push(record['outDateRunningTotal']);
      arrayOfArrays.push(array);
    }
    var data = google.visualization.arrayToDataTable(arrayOfArrays);
    var options = {
      title: 'In & Out Date Totals',
      hAxis: {title: `${this.displayYear} ${this.displayQuarter}`, textStyle: {fontSize: 12}, format: 'MMM dd, yyyy'},
      vAxis: {viewWindow: {max:this.logData.length, min:0}, textStyle: {fontSize: 12}},
      colors: ['#36A2EB', '#77dd77']
    };
    var chart = new google.visualization.AreaChart(document.getElementById('chartDiv'));
    chart.draw(data, options);
  }

  validateInAndOutDate(date, year, quarter) {
    let quarterStart = moment().year(year).quarter(quarter).startOf('quarter');
    if (moment(date).isBetween(quarterStart, moment(), null, '[]')) { // [] means inclusive on both date ends
      return true;
    } else {
      return false;
    }
  }

  validateYearAndQuarter(year, quarter) {
    let quarterStart = moment().year(year).quarter(quarter).startOf('quarter');
    if (quarterStart.isSameOrBefore(this.currentQuarterStart))
      return true;
    else
      return false;
  }

  exportCSV() {
    if (!this.logData)
      return;
    if (this.logData.length == 0) {
      swal('Error:', 'Table must contain at least one record to export.', 'warning');
      return;
    }
    let data: any = [];
    let columnMap : Map<string,string> = new Map<string, string>();
    columnMap.set('payerId', 'Payer ID');
    columnMap.set('clientName', 'Payer Name');
    columnMap.set('inDate', 'In Date');
    columnMap.set('outDate', 'Out Date') ;
    columnMap.set('deliveryMode', 'Delivery Mode');
    columnMap.set('status', 'Status');
    columnMap.set('internalComments', 'Internal Comments');
    columnMap.set('clientComments', 'Client Comments');
    columnMap.set('assignedTo', 'Assigned To');
    columnMap.set('taskStatus', 'Task Status');
    columnMap.set('iManageURL', 'iManage Workspace URL');
    let columns: any = [];
    for (let colName of Array.from(columnMap.values())) {
      columns.push(colName);
    }
    data.push(columns);
    for(let row of this.logData) {
      let record: any = [];
      for (let col of Array.from(columnMap.keys())) {
        record.push(row[col] || '');
      }
      data.push(record);
    }
    alasql.promise('SELECT * INTO CSV("LOGBOOK_EXPORT.CSV", {headers:false, separator:","\}) FROM ?', [data])
      .then(function () {
        console.log('Data saved');
      }).catch(function (err) {
        console.log('Error:', err);
      });
  }

  goToiManageWorkspace(data) {
    if(data.iManageURL == null || data.iManageURL == "") {
      var htmlText = document.createElement("span");
      htmlText.innerHTML = 'No iManage Workspace URL has been entered for this record.<br />Please edit this record and submit the workspace URL for this client.';
      swal({
        title: 'Error:',
        content: htmlText,
        icon: 'warning',
      })
    } else {
      window.open(data.iManageURL, '_blank');
    }
   
  }
}




// WEBPACK FOOTER //
// ./src/app/log-book/log-book.component.ts